import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthenticationHelper } from '../../../helpers/authenticationHelper';
import { OnboardingProgressService } from '../services/onboarding-progress.service';

/**
 * Allows the Gamification routes only when the project has `automation_enabled`.
 * Reads the session store (hydrated by GamificationSessionGuard), not cookies.
 */
export const GamificationModeGuard: CanActivateFn = () => {
    const authService = inject(AuthenticationHelper);
    const onboarding = inject(OnboardingProgressService);
    const router = inject(Router);

    if (!authService.isLoggedIn()) {
        return router.createUrlTree(['sign-in']);
    }

    if (onboarding.isGamificationMode()) {
        return true;
    }

    return router.createUrlTree(['feeds']);
};
